import { Component, Input } from '@angular/core';
import { GameGroupPrizeType, Prize } from '@fgb/core';

@Component({
  selector: 'fgbcl-game-result-prize',
  templateUrl: './game-result-prize.component.html',
  styleUrl: './game-result-prize.component.scss',
})
export class GameResultPrizeComponent {
  @Input() prize: Prize;
  prizeType = GameGroupPrizeType;
}
